import { Dispatch, SetStateAction } from 'react'
import { Player } from '../assets/data'
import { Link } from 'react-router-dom'
import slugify from 'slugify'
interface PlayerCardProps {
  player: Player
  setDetails: Dispatch<SetStateAction<null | Player >>
}
export const PlayerPreview = ({ player, setDetails }: PlayerCardProps) => {
  const style = {
    height: '10rem',
    width: '7rem',
    'object-fit': 'cover'
  }
  return (
    <div title={player.name} onClick={() => setDetails(player)}>
      <Link to={slugify(player.name)}>
        <img style={style} src={player.image} alt={player.name} />
      </Link>
    </div>
  )
}